const getters = {
    token: state => state.user.token,
    // language: state => state.common.language,
    // website: state => state.common.website,
    userInfo: (state, getters) => getters['user/userInfo'],
    isAdmin: (state, getters) => getters['user/isAdmin'],
    isTeacher: (state, getters) => getters['user/isTeacher'],
    isStudent: (state, getters) => getters['user/isStudent'],
    isDeptAdmin: (state, getters) => getters['user/isDeptAdmin'],
    loginVisible: state => state.common.loginVisible,
    pulseLoader: state => state.common.pulseLoader,
    // colorName: state => state.common.colorName,
    // themeName: state => state.common.themeName,
    // isShade: state => state.common.isShade,
    // isCollapse: state => state.common.isCollapse,
    curExpInfo: state => state.common.curExp,
    // screen: state => state.common.screen,
    // isLock: state => state.common.isLock,
    // isFullScren: state => state.common.isFullScren,
    // lockPasswd: state => state.common.lockPasswd,
    questionTypeList: state => state.common.questionTypeList, // 题目类型列表
    // keyCollapse: (state, getters) => getters.screen > 1 ? getters.isCollapse : false,
    // roles: state => state.user.roles,
    // permission: state => state.user.permission,
    // menu: state => state.user.menu,
    // menuAll: state => state.user.menuAll,
    isRefresh(state) {
        if (localStorage.getItem('isRefresh')) {
            state.common.isRefresh = localStorage.getItem('isRefresh')
        }
        return state.common.isRefresh
    }
}

export default getters